// @core/api/endpoints/booking/get_booking_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingTypeDefinitionResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Get booking type
 * Returns a booking type definition by ID or slug.
 */
export async function GetBookingType(
  type_id: string,
  options?: RequestOptions
): Promise<BookingTypeDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.get<BookingTypeDefinitionResponse>(requestPath, { ...requestOptions });
}
